var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#211D1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M23 23.5H8.725L5.238 4.325a1 1 0 0 0-.976-.825H2M10 28.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M23 28.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#211D1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.813 18.5h15.7a1.99 1.99 0 0 0 1.962-1.637L27 8.5H6"
})));
export default SvgBasket;